import { storage } from '@utils/session-storage'

export function analyticCheckoutStart(
  cart
) {
  console.log(cart);
  const [cartItem] = cart;
  console.log(cartItem);
  const started = storage.getItem('begin_checkout')
  if (started && Number(started) === cartItem.total_price) return

  window.dataLayer = window.dataLayer || []

  const data = cartItem.groups.map(element => ({
    item_name: element.base.element.props.title,
    item_id: element.base.element.id,
    price: element.base.element.props.price,
    quantity: element.base.quantity,
  }))
  window.dataLayer.push({
    event: 'begin_checkout',
    ecommerce: {
      items: data,
    },
  })
  storage.setItem('begin_checkout', cart.total_price)
}
